import { Button } from '@mantine/core';
import { useNavigate } from 'react-router';
import { useSiestaPrepStore } from 'src/UI/app-container/useSiestaPrepStore';
import { useClient } from 'src/clients/hooks/useClient';
import type { Notification } from 'src/notifications/types/Notification';
import { formatName, NameFormat } from 'src/utils/nameFormatting';

const CLIENT_TOKEN = '{client}';

export default function PrepWithSiestaButton({
  notification,
  clientId,
  onClose,
}: {
  notification: Notification;
  clientId: string;
  onClose: () => void;
}) {
  const navigate = useNavigate();
  const requestPrep = useSiestaPrepStore(state => state.requestPrep);
  const { client } = useClient(clientId);

  const clientName = client
    ? formatName(client.firstName, client.lastName, NameFormat.NATURAL)
    : undefined;
  const anchor = notification.siestaAnchor.replace(CLIENT_TOKEN, clientName ?? 'this client');

  return (
    <Button
      size="sm"
      variant="primary"
      onClick={event => {
        event.stopPropagation();
        navigate(`/client/${clientId}`);
        requestPrep({ notificationId: notification.id, clientId, anchor });
        onClose();
      }}
    >
      Prep with Siesta
    </Button>
  );
}
